<template>
  <b-modal
    body-class="mymodalSize"
    content-class="mymodalContent"
    modal-class="mymodal"
    id="editorialContent"
    size="lg"
    centered
    scrollable
    hide-header
    hide-footer
  >
    <close-icon :title="$t('global.closePopinTitle')" @click="$bvModal.hide('editorialContent')" />
    <div class="modal-div">
      <p v-html="content"></p>
    </div>  
  </b-modal>
</template>

<script>
import CloseIcon from "vue-material-design-icons/Close.vue";

export default {
  name: "PopinEditorialContent",
  components: {
    CloseIcon
  },
  props: {
    content: String
  }
};
</script>

<style lang="sass">
// le CSS de la modal ne doit pas être scoped
.mymodalSize
  height: 40em
  
.left-btn
  position: absolute
  left: 10px
</style>
